import { DocumenttypeDisplayModel, GlobalEnumerationsAceMittelabrufzahlung, GlobalEnumerationsAceMittelabruf, GlobalEnumerationsAceXfoundportalobjekt, PaymentDisplayModel, PortalkonfigurationDisplayModel, GlobalEnumerationsAceRechtsform, LocalizedTextDisplayModel, DocumentDisplayModel } from '@/api/model-index';
import { AnfrageService } from '@/api/service-index';
import { Constants } from '@/constants';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { NumberFormatOptions } from '@progress/kendo-angular-intl';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { I18nService } from '@/core/services/i18nService';
import { PaymentService } from '@/core/services/payment.service';
import { ConfirmationDialogAction, ConfirmationDialogResult } from '@/core/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { StateService } from '@/core/services/state.service';

@Component({
    selector: 'app-mittelabruf-dialog',
    templateUrl: './mittelabruf-dialog.component.html',
    styleUrls: ['./mittelabruf-dialog.component.scss'],
    standalone: false
})
export class MittelabrufDialogComponent extends DialogContentBase implements OnInit {
  
  @Input() public anfrageId!: string;
  @Input() public payment: PaymentDisplayModel | null;
  @Input() public scope!: GlobalEnumerationsAceXfoundportalobjekt;
  @Input() public dokumententyp?: DocumenttypeDisplayModel;
  @Input() public documentsForm: UntypedFormControl;
  @Input() public type: GlobalEnumerationsAceMittelabruf;
  @Input() public portalkonfiguration: PortalkonfigurationDisplayModel;
  @Input() public foerdersummeOffen: number | null | undefined = 0;
  @Input() public foerdersummeOffenChange = new EventEmitter<number>();

  protected _rechtsform: GlobalEnumerationsAceRechtsform | null;

  public form: FormGroup;

  public currencyFormatOptions: NumberFormatOptions = Constants.CURRENCY_FORMAT_OPTIONS;

  constructor(
    public dialog: DialogRef,
    protected anfrageService: AnfrageService,
    protected loadingAnimationService: LoadingAnimationService,
    protected notificationService: NotificationService,
    protected translationService: I18nService,
    protected paymentService: PaymentService,
    protected stateService: StateService
    ) {
    super(dialog);

    this.form = new FormGroup({
      amount: new FormControl(0),
    });
  }

  public get canSubmit(): boolean {
    if (this.dokumententyp)
    {
      // If is upload required and if documents uploaded => true
      if (this.isUploadRequired()) {
        return this.documentsForm.value.length > 0;
      }
    }

    return true;
  }

  public ngOnInit() {
    if (this.payment && this.amountIsFixed) {
      this.form.controls.amount.patchValue(this.payment.amount ?? 0);
    }
  }

  public get amountIsFixed(): boolean {
    return this.portalkonfiguration.artDesMittelabrufs == GlobalEnumerationsAceMittelabruf.Zahlung && this.portalkonfiguration.mittelabrufZahlung == GlobalEnumerationsAceMittelabrufzahlung.Betragfix;
  }

  public get now(): Date {
    return new Date();
  }

  public isUploadRequired(): boolean {
    return (this.dokumententyp && this.dokumententyp.isUploadRequired == true) ?? false;
  }

  // Zahlungsdatum wird nur angezeigt wenn Mittelabruf = Zahlung
  public get showPaymentDate(): boolean {
    return this.type === GlobalEnumerationsAceMittelabruf.Zahlung;
  }

  public closeDialog(action: ConfirmationDialogAction): void {
    let result: ConfirmationDialogResult = new ConfirmationDialogResult();

    result.action = action;

    this.dialog.close(result);
  }
  
  public onCancelClick(): void {
    this.closeDialog(ConfirmationDialogAction.Cancel);
  }

  public toDate(value: string): Date
  {
    return new Date(value);
  }

  public getDocumentTypeName(model: DocumenttypeDisplayModel | undefined) {
    if (! model)
      return "";

    let title: LocalizedTextDisplayModel | undefined = this.translationService.getCurrentLocalizedTextDisplayModel(model.name);
    return title?.text ?? "";
  }

  
  public getDocumentTypeInfotext(model: DocumenttypeDisplayModel | undefined) {
    if (! model)
      return "";

    let title: LocalizedTextDisplayModel | undefined = this.translationService.getCurrentLocalizedTextDisplayModel(model.infotext);
    return title?.text ?? "";
  }

  onDocumentDelete(index: any): void {
    this.documentsForm.value.splice(index, 1);
    if (this.stateService.IsEndvalidationEnabled)
      this.documentsForm.updateValueAndValidity();
  }

  onDocumentUpload(document: DocumentDisplayModel): void {
    this.documentsForm.value.push(document);
  }

  public onSubmitClick(): void {
    if (this.portalkonfiguration.artDesMittelabrufs == GlobalEnumerationsAceMittelabruf.Forderbetrag && this.form.controls.amount.value <= 0) {
      this.notificationService.show({
        content: this.translationService.instant("amountLowerOrEqualZero"),
        animation: { type: "fade", duration: 500 },
        position: { horizontal: "center", vertical: "bottom" },
        type: { style: "error", icon: true },
      });

      return;
    } else if (this.portalkonfiguration.artDesMittelabrufs == GlobalEnumerationsAceMittelabruf.Forderbetrag && this.foerdersummeOffen && this.form.controls.amount.value > this.foerdersummeOffen) {
      this.notificationService.show({
        content: this.translationService.instant("amountHigherThanAvailableAmount"),
        animation: { type: "fade", duration: 500 },
        position: { horizontal: "center", vertical: "bottom" },
        type: { style: "error", icon: true },
      });

      return;
    }
    
    if (this.portalkonfiguration.artDesMittelabrufs == GlobalEnumerationsAceMittelabruf.Zahlung && this.payment && this.payment.amount != null && this.form.controls.amount.value <= 0) {
      this.notificationService.show({
        content: this.translationService.instant("amountLowerOrEqualZero"),
        animation: { type: "fade", duration: 500 },
        position: { horizontal: "center", vertical: "bottom" },
        type: { style: "error", icon: true },
      });

      return;
    } else if (this.portalkonfiguration.artDesMittelabrufs == GlobalEnumerationsAceMittelabruf.Zahlung && this.payment && this.payment.amount != null && this.form.controls.amount.value > this.payment.amount) {
      this.notificationService.show({
        content: this.translationService.instant("amountHigherThanAvailableAmount"),
        animation: { type: "fade", duration: 500 },
        position: { horizontal: "center", vertical: "bottom" },
        type: { style: "error", icon: true },
      });

      return;
    }

    let subscription = this.anfrageService.apiAnfrageAnfrageIdFundsPaymentPatch({
      "x-anfragescope": this.scope,
      anfrageId: this.anfrageId,
      paymentId: this.payment?.id,
      body: this.form.controls.amount.value
    }).subscribe(() => {
      this.closeDialog(ConfirmationDialogAction.Confirm);
      this.anfrageService.apiAnfrageAnfrageIdFundsPaymentsGet({ anfrageId: this.anfrageId }).subscribe(response => {
        this.paymentService.formGroup.patchValue(response);
        this.paymentService.payments = response.payments ?? [];
        this.paymentService.formGroup.FoerdersummeOffen.patchValue(response.foerdersummeOffen);
        this.foerdersummeOffenChange.emit(response.foerdersummeOffen ?? 0);
      });
    });

    this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
  }
}
